<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>تقرير الخزنة</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                                <ul v-if='mainValidationErrors'>
                                    <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class="row">
                              <div class='col-lg-4 col-md-4 col-sm-6'>
                                    <label>الفرع</label>
                                    <select class="form-control"  v-model="branche">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <tbDate  :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <tbDate  :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                              </div>
                                  <div style="padding-top:25px" class='col-lg-1 col-md-1 col-sm-6'>
                                      <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                        <b> عرض </b>
                                      </button>
                                  </div>
                                  </div>
                                  <br>
                                  <p class="text-success">الاجمالى: {{totalItem}}</p>
                                  <div class="col-lg-6 col-md-6 col-sm-6  table-responsive">
                                  <table width='100%' class='table'>
                                      <thead>
                                        <tr>
                                            <th style='text-align: center;width:25%'>المبلغ</th>
                                            <th style='text-align: center;width:75%'>بيان</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr class='odd gradeX'>
                                          <td align='left'>7500.00</td>
                                          <td align='right'>مبيعات مباشرة</td>
                                        </tr>
                                        <tr class='odd gradeX'>
                                          <td align='left'>25250.00</td>
                                          <td align='right'>مقدمات العقود</td>
                                        </tr>
                                        <tr class='odd gradeX'>
                                          <td align='left'>24450.00</td>
                                          <td align='right'>متحصلات الأقساط</td>
                                        </tr>
                                        <tr class='odd gradeX'>
                                          <td align='left'>821.00</td>
                                          <td align='right'>الصيانة</td>
                                        </tr>
                                        <tr class='odd gradeX'>
                                          <td align='left'>0.00</td>
                                          <td align='right'>متحصلات من العملاء</td>
                                        </tr>
                                        <tr class='odd gradeX'>
                                          <td align='left'>12.00</td>
                                          <td align='right'>إيرادات أخرى</td>
                                        </tr>
                                        <tr class='odd gradeX'>
                                          <td align='left'>58360.00</td>
                                          <td align='right'>إجمالى الايرادات</td>
                                        </tr>
                                      </tbody>
                                  </table>
                                <!-- /.table-responsive -->
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6  table-responsive">
                              <table width='100%' class='table'>
                                  <thead>
                                    <tr>
                                      <th style='text-align: center;width:25%'>المبلغ</th>
                                      <th style='text-align: center;width:75%'>بيان</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                      <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                        <td align='left'>{{record.amount}}</td>
                                        <td align='right'>{{record.main}} - {{record.sub}}</td>
                                      </tr>
                                  </tbody>
                              </table>
                            <!-- /.table-responsive -->
                          </div>
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import tbDate from '@/components/myComponents/tbDate'
import axios from 'axios'
export default {
  components: {
    tbDate
  },
  name: 'RecordRevenueExpenses',
  data () {
    return {
      dateTitle: 'التاريخ',
      fromTitle: 'من',
      toTitle: 'إلى',
      from_date: '',
      to_date: '',
      validationErrors: '',
      mainValidationErrors: '',
      records: {},
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      RevenueExpense: [],
      branche: '',
      treasuries: {},
      branches: {},
      types: [{id: 1, name: 'مصروف'}, {id: 0, name: 'إيراد'}],
      title: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.record.branches_id = this.branches[0].id
  },
  computed: {
    totalItem () {
      let total = 0
      if (Object.keys(this.records).length !== 0) {
        this.records.forEach(function (item) {
          total += (parseFloat(item.amount))
        })
      }
      return total
    }
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getRecordRevenueExpenses', {
        token: localStorage.getItem('token'),
        branche: this.branche,
        date_from: this.from_date,
        date_to: this.to_date
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.mainValidationErrors = ''
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Accounts/TreasuryReport.vue